module.exports = __webpack_public_path__ + "img/vr-space-desktop.666fc073.jpg";